// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.00002 2C3.34318 2 2.00004 3.34313 2.00002 4.99997L2 22H19C20.6568 22 22 20.6569 22 19V9C22 7.34314 20.6568 6 19 6H5.00002C4.44773 6 4.00001 5.55228 4.00002 4.99999C4.00003 4.44771 4.44774 4 5.00002 4H20V2H5.00002ZM18 15H15V13H18V15Z"}}]};

const WalletFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wallet-filled',
    ref,
    icon: element,
  },
));

WalletFilledIcon.displayName = 'WalletFilledIcon';

export default WalletFilledIcon;
